import { Typography, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { getUser } from "../../slices/user";

// One table page renders this component once per row. Without cross-cell de-duplication
// every row fired its own /user request on mount -- 25 rows meant 25 concurrent requests,
// each landing a store update that re-rendered every other cell.
const requestedUsernames = new Set();

const isLookupWorthy = (username) =>
  !!username && username !== "" && username !== "All";

const NiceUser = (props) => {
  const dispatch = useDispatch();

  const wantedUser = props.children;

  // Read the username-keyed lookup cache. `null` means "asked, not found" -- a resolved
  // miss, which must not trigger another request.
  const user = useSelector((state) =>
    isLookupWorthy(wantedUser) ? state.users.lookups?.[wantedUser] : undefined
  );

  const isResolved = useSelector((state) =>
    isLookupWorthy(wantedUser)
      ? Object.prototype.hasOwnProperty.call(state.users.lookups ?? {}, wantedUser)
      : true
  );

  useEffect(() => {
    if (!isLookupWorthy(wantedUser) || isResolved || requestedUsernames.has(wantedUser)) {
      return;
    }

    requestedUsernames.add(wantedUser);
    dispatch(getUser({ username: wantedUser }));
  }, [wantedUser, isResolved, dispatch]);

  return (
    <>
      {user ? (
        <Box display="flex" justifyContent="start" alignItems="baseline">
          <Typography display="inline">{`${user.firstName} ${user.lastName}`}</Typography>
          <Typography variant="title" color="inherit" noWrap>
            &nbsp;
          </Typography>
          <Typography
            variant="small"
            display="inline"
          >{`(${user.username})`}</Typography>
        </Box>
      ) : (
        <Box display="flex" justifyContent="start" alignItems="baseline">
          <Typography display="inline">{wantedUser}</Typography>
        </Box>
      )}
    </>
  );
};

export default React.memo(NiceUser);
